import "@fontsource/pixelify-sans/400.css";
import "@fontsource/pixelify-sans/700.css";
import { installWavedashStub } from "./platform/wavedash.js";
import "./styles.css";
import { boot } from "./game/runtime.js";

installWavedashStub();

boot().catch((err) => {
  console.error("[afters] boot failed", err);
  const ui = document.getElementById("ui");
  if (ui) {
    ui.textContent = `Boot failed: ${err?.message || err}`;
    ui.style.cssText =
      "color:#fcc;font:14px/1.4 system-ui;padding:1.5rem;opacity:1";
  }
});
